import React, { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { connect } from "react-redux";

import { consts as cfgConsts, selectors as cfgSelectors } from '../../../redux/modules/configuracoes';
import themes from '../../../core/constants/theme';
import themeService  from "../../services/theme";

const initialTheme = {
    ...themes,
    colors:{
        iconFilter:false,
        header:"#ffffff",
        headerlabel:"#000000",
        headerIconColor:"#00000099",
    
        tableHeader:"#ffffff",
        tableLabel:"#00000099",
        tableSpan:"#f05d2c",
    
        menuActived:"#f05d2c29",
        menuLabelActived:"#f05d2c",
        menuLabel:"#00000099",
    
        borderCombos:"#f05d2c",
        iconCombos:"#00000099",
        colorCombos:"#f05d2c",
        selectedCombos:"#00000099",
        labelCombos:"black",
    
        borderButton:"#f05d2c",
        iconButton:"#00000099",
        colorButton:"#f05d2c",
        colorLightButton:"#f05d2c29",
        colorLabelButton:"#f05d2c",
        colorLabelLightButton:"#ffffff",
    
        linkLabel:"#f05d2c",
        light:"#ffffff",
        colorConfJson:"#f05d2c",
    
        colorCircle:"#f05d2c",
        chatColor:"#f05d2c",
    
        colorPag:"#f05d2c",
    
        modalHeaderColor:"#f05d2c",
        modalButtonClose:"#000000",
        
        sucess:"#0f5132",
        successLight:"#d1e7dd",
        successLightBorder:"#badbcc",
        danger:"#842029",
        dangerLight:"#f8d7da",
        dangerLightBorder:"#f5c2c7",
        buttonGovBr:"rgb(18,81,180)",
        buttonLightGovBr:"rgba(18,81,180,0.1)"
    }
}

const HASH_THEMA = '0665cf4aff85583e0b31d5eb0e40b221';

const UseTheme = ({children, config}) => {

    const [themeLoaded, setThemeLoaded] = useState(false);
    const [theme, setTheme] = useState(initialTheme);

    async function buscaTema() {
        try{
            const themeColor = await themeService.getTheme(HASH_THEMA);
            if(themeColor){
                setTheme({
                    ...themes,
                    colors:themeColor
                });
                
            }
        }finally{
            setThemeLoaded(true);
        }
    };

    useEffect( () => {
        buscaTema();
    },[config]);

    return (
        <>
            { themeLoaded &&
                <ThemeProvider theme={theme}>
                    {children}
                </ThemeProvider>
            }
        </>
    );
}

function mapStateToProps(state) {
	return {
		config: cfgSelectors.getValorConfiguracao(state, cfgConsts.APPLICATION_CONFIG_RESOURCES)
	};
}

export default connect(mapStateToProps)(UseTheme);